<template>
  <div class="SwiperSlider">
    <div class="SwiperSlider-item">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SwiperSlider'
}
</script>
<style lang="scss" scoped>
.SwiperSlider{
  height: 100%;
  position: relative;
  overflow: hidden;
  flex: 1;
  .SwiperSlider-item{
    float: left;
    width: 100%;
    height: 100%;
  }
}
</style>
